module.exports = __webpack_public_path__ + "static/media/bottom-shield-big.ed1c8ff0.svg";